var _defs, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnswers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#Sfumatura_senza_nome_5);\n      }\n\n      .st1 {\n        fill: none;\n        stroke: #19233e;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 23px;\n      }\n\n      .st2 {\n        fill: #19233e;\n      }\n\n      .st3 {\n        fill: url(#Sfumatura_senza_nome_4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_5",
    "data-name": "Sfumatura senza nome 5",
    x1: 343.5,
    y1: -74.9,
    x2: 343.5,
    y2: 209.7,
    gradientTransform: "translate(0 369.3) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0075be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36a9e1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_4",
    "data-name": "Sfumatura senza nome 4",
    x1: 160,
    y1: -23.7,
    x2: 152.8,
    y2: 437,
    gradientTransform: "translate(0 369.3) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbd143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9e8ae"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.9,159.6h279.3c9.2,0,16.7,7.5,16.7,16.7v184.6c0,9.2-7.5,16.7-16.7,16.7h-29.6v4.7l.2,54.2c.1,7.3-9.3,10.5-13.7,4.7l-62.6-63.6h-173.6c-9.2,0-16.7-7.5-16.7-16.7v-184.6c0-9.2,7.4-16.7,16.6-16.7h.1,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M396.9,310.3c0,2.2-.8,4.2-2.3,5.8-1.6,1.6-3.2,2.5-5.2,2.5-3.5,0-17.8-10-42.9-29.9l-21.9,23.1c-5.5,5.6-9.4,8.3-11.6,8.3s-4.3-.9-5.8-2.5c-1.6-1.5-2.5-3.6-2.5-5.8s3.1-6.8,9.2-12.3c10.4-9.4,17.8-16.7,22.5-21.8-15.2-15.1-25.3-28.6-30.2-40.5-3.1-1.7-4.6-4-4.6-6.7s.8-4.4,2.4-6c1.4-1.6,3.5-2.5,5.6-2.5,3-.1,5.8,1.2,7.6,3.5,1.4,1.6,3.2,4.9,5.6,9.9,4.3,9.2,12.2,19.4,23.7,30.4,8.6-9.6,15.2-18.9,19.7-28,1.6-3.7,3.2-7.4,4.9-11.1,1.6-3,3.9-4.5,6.9-4.5,2.2-.1,4.4.7,6,2.3,1.6,1.5,2.3,3.5,2.3,6,0,9.5-9.3,25.3-27.9,47.3,4.9,4.2,14.2,11.1,27.8,20.7,7.1,4.9,10.7,8.9,10.7,11.8h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M296.1,52.4H16.7c-9.2,0-16.7,7.5-16.7,16.7v184.6c0,9.2,7.5,16.7,16.7,16.7h29.6v4.7l-.2,54.2c0,7.3,9.3,10.5,13.7,4.7l62.6-63.5h173.7c9.2,0,16.7-7.5,16.7-16.7V69.1c0-9.2-7.4-16.7-16.6-16.7,0,0-.1,0-.1,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.7,164.8l35.3,36.7,40.6-82.9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswers);
export default __webpack_public_path__ + "static/media/answers.b6b637948b9a625036f10584e883b14c.svg";
export { ForwardRef as ReactComponent };